import { getPhones } from './getPhones';
import { IState } from '../../store';
import { IValidPhone } from '../../types/offerData';

export const selectDynamicPhones = (state: IState): IValidPhone[] | null => state.dynamicPhones;

/** Номера для показа в блоках контактов: подменные динКТ (SEL-998), иначе статические */
export function getActualPhones(state: IState): IValidPhone[] {
  return state.dynamicPhones ?? getPhones(state);
}
